import { render } from "./TVPLowVariance.vue?vue&type=template&id=f7eec36e"
import script from "./TVPLowVariance.vue?vue&type=script&lang=js"
export * from "./TVPLowVariance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__